import { Route } from "react-router";
import "./App.css";
import { Navbar } from "./Components/Navbar";

import RecipeForm from "./Components/RecipeForm";
import RecipeBook from "./Components/RecipeBook";
import Login from "./Components/User/Login";
import CreateAccount from "./Components/User/CreateAccount";
import PrivateRoute from "./Helpers/PrivateRoute";
import EditRecipe from "./Components/EditRecipe";
import SingleRecipe from "./Components/SingleRecipe";

function App() {
	return (
		<div className="App">
			<br />
			<Navbar />
			<PrivateRoute exact path="/" component={RecipeBook} />
			<Route exact path="/login" component={Login} />
			<PrivateRoute exact path="/newrecipe" component={RecipeForm} />
			<PrivateRoute exact path="/recipebook" component={RecipeBook} />
			<Route exact path="/createaccount" component={CreateAccount} />
			<PrivateRoute path="/recipes/edit/:id" component={EditRecipe} />
			<PrivateRoute path="/recipe/:id" component={SingleRecipe} />
		</div>
	);
}

export default App;
